import { render, staticRenderFns } from "./order-modal-address.vue?vue&type=template&id=4473d94b&scoped=true"
import script from "./order-modal-address.vue?vue&type=script&lang=js"
export * from "./order-modal-address.vue?vue&type=script&lang=js"
import style0 from "./order-modal-address.vue?vue&type=style&index=0&id=4473d94b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473d94b",
  null
  
)

export default component.exports